import styled from '@emotion/styled';
import React from 'react';

const StyledDivMenuDropdown = styled.div({
  display: 'inline-flex',
  alignContent: 'center',
  justifyContent: 'center',
  position: 'relative',
  zIndex: 20
});

export default React.memo(StyledDivMenuDropdown);
